module.exports = __webpack_public_path__ + "static/media/spade-icon.08082a79.svg";